module.exports = __webpack_public_path__ + "static/img/111_TO8_1813_og.6d2233d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/111_TO8_1813_og.jpg
// module id = 9la6
// module chunks = 0